import { sortSegments } from "@memento/library/segment";
import type { Segment } from "@memento/types/segment";

export function fillSortOrderGaps(segments: Segment[]) {
  const segmentsSorted = sortSegments([...segments]);

  return segmentsSorted.map((segment, idx) => {
    return {
      ...segment,
      sortOrder: idx,
    };
  });
}
